<div class="site">
  <header class="as-header">
    <nav class="as-menu as-wrapper" role="navigation">
      <ul class="as-menu__left">
        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.DROP_DOWN_MENUS].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.DROP_DOWN_MENUS].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.DROP_DOWN_MENUS].active,
          'locked': examRestrictionsAreActive
          }" id="MAIN_MENU">
          <asg-dropdown [image]="'fas fa-bars'" [items]="mainMenu" [uiState]="uiState" [id]="'dropdownMainMenu'">
          </asg-dropdown>
        </li>
        <li class="tools-menu" [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.DROP_DOWN_MENUS].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.DROP_DOWN_MENUS].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.DROP_DOWN_MENUS].active,
          'locked': uiState && uiState[AsgardFeatureNames.AUDIO_MAKER].locked 
                            && uiState[AsgardFeatureNames.WORD_PREDICTION].locked
                            && uiState[AsgardFeatureNames.SPELL_CHECK].locked
                            && uiState[AsgardFeatureNames.SCREENSHOT_READER].locked
          }" id="TOOLS_MENU">
          <asg-dropdown [image]="'fas fa-tools'" [items]="toolsMenu" [uiState]="uiState" [id]="'dropdownToolsMenu'">
          </asg-dropdown>
        </li>

        <!-- ASG-146 -->
        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.SPEECH_RECOGNITION].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.SPEECH_RECOGNITION].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.SPEECH_RECOGNITION].active
          }" id="SPEECH_RECOGNITION" asgTooltip="TOP_BAR_BTNS.SPEECH_RECOGNITION"
          [asgMenuItemAdjuster]="speechRecognition">
          <asg-desktop-menu-item [item]="speechRecognition" [uiState]="uiState"></asg-desktop-menu-item>
        </li>

        <!-- ASG-1640 -->
        <!-- asgMenuItemAdjuster will collaplse 3 items into one, on tablets -->
        <!-- so we just pass one item for directive for example toolbar from component -->
        <li class="collapsed-features_menu" [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.COLLAPSED_FEATURES_MENU].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.COLLAPSED_FEATURES_MENU].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.COLLAPSED_FEATURES_MENU].active
          }" [hidden]="!collapsedFeaturesMenu.length">
          <asg-dropdown [image]="'fad fa-pencil-paintbrush'" [items]="collapsedFeaturesMenu" [uiState]="uiState"
            [id]="'dropdownMarkUpMenu'">
          </asg-dropdown>
        </li>

        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.TOOLBAR_MENU].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.TOOLBAR_MENU].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.TOOLBAR_MENU].active
          }" id="TOOLBAR_MENU" asgTooltip="TOP_BAR_BTNS.TEXT_NOTES" [hidden]="!!collapsedFeaturesMenu.length"
          [asgMenuItemAdjuster]="toolbar">
          <asg-desktop-menu-item [item]="toolbar" [uiState]="uiState"></asg-desktop-menu-item>
        </li>

        <!-- ASG-962 -->
        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.DRAWING_TOOLS].disabled,
          'hidden': hideDrawingTools || uiState && uiState[AsgardFeatureNames.DRAWING_TOOLS].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.DRAWING_TOOLS].active
          }" id="DRAWING_TOOLS" asgTooltip="TOP_BAR_BTNS.DRAWING_TOOLS" [hidden]="!!collapsedFeaturesMenu.length">
          <asg-desktop-menu-item [item]="drawingTools" [uiState]="uiState"></asg-desktop-menu-item>
        </li>
        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.HIGHLIGHT_MENU].disabled,
          'hidden':uiState &&  uiState[AsgardFeatureNames.HIGHLIGHT_MENU].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.HIGHLIGHT_MENU].active
          }" id="HIGHLIGHT_MENU" asgTooltip="TOP_BAR_BTNS.MARKERS" [hidden]="!!collapsedFeaturesMenu.length">
          <asg-desktop-menu-item [item]="highlightBar" [uiState]="uiState"></asg-desktop-menu-item>
        </li>
        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.EPUB_MENU].disabled,
          'hidden':uiState &&  uiState[AsgardFeatureNames.EPUB_MENU].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.EPUB_MENU].active
          }" id="EPUB_MENU" asgTooltip="TOP_BAR_BTNS.EPUB_ANNOTATIONS" [hidden]="!!collapsedFeaturesMenu.length">
          <asg-desktop-menu-item [item]="epubBar" [uiState]="uiState"></asg-desktop-menu-item>
        </li>
      </ul>

      <ul class="as-menu__play">
        <asg-reading-toolbar></asg-reading-toolbar>
      </ul>
      <ul class="as-menu__pointer">
        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.MARKUP_MENU].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.MARKUP_MENU].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.MARKUP_MENU].active
          }" id="MARKUP_MENU" asgTooltip="TOP_BAR_BTNS.READING_MODES" [asgMenuItemAdjuster]="textSettingsBar">
          <asg-desktop-menu-item [item]="textSettingsBar" [uiState]="uiState"></asg-desktop-menu-item>
        </li>
      </ul>
      <ul class="as-menu__lang">
        <li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.SEARCH].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.SEARCH].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.SEARCH].active
          }" id="SEARCH" asgTooltip="TOP_BAR_BTNS.SEARCH" [asgMenuItemAdjuster]="search">
          <asg-desktop-menu-item [item]="search" [uiState]="uiState"></asg-desktop-menu-item>
        </li>
        @for (item of langMenu; track item) {
          <li [asgTooltip]="item.tooltip" [asgMenuItemAdjuster]="item">
            <asg-desktop-menu-item [item]="item" [uiState]="uiState"></asg-desktop-menu-item>
          </li>
        }
      </ul>

      <ul class="as-menu__right">
        @if (isExamModeAccessible && !isSiteAdmin) {
<li [ngClass]="{
          'disabled': uiState && uiState[AsgardFeatureNames.EXAM_MODE_WINDOW].disabled,
          'hidden': uiState && uiState[AsgardFeatureNames.EXAM_MODE_WINDOW].hidden,
          'active-menu-item': uiState && uiState[AsgardFeatureNames.EXAM_MODE_FLOATING_TOOLBAR].active,
          'unsupported-browser': !isBrowserSupported
          }" id="EXAM_MODE_FLOATING_TOOLBAR" [asgTooltip]="isBrowserSupported ? 'TOP_BAR_BTNS.EXAM_MODE' : 'TOP_BAR_BTNS.EXAM_MODE_UNSUPPORTED_BROWSER'" [asgMenuItemAdjuster]="examModeMenu">
            <asg-desktop-menu-item [item]="examModeMenu" [uiState]="uiState"></asg-desktop-menu-item>
          </li>
        }
        @for (item of settingsMenu; track item) {
          <li [asgTooltip]="item.tooltip" [asgMenuItemAdjuster]="item">
            <asg-desktop-menu-item [item]="item" [uiState]="uiState"></asg-desktop-menu-item>
          </li>
        }
        <!-- <div class="toggle-bottom-bar">
        <asg-toggle-bottom-bar></asg-toggle-bottom-bar>
      </div> -->
    </ul>
  </nav>
</header>

<!-- main content -->
<main class="site-content">
  <asg-pane-list></asg-pane-list>
</main>
@defer (on immediate) {
  <asg-toolbar-floating-menu [uiState]="uiState"></asg-toolbar-floating-menu>
  <asg-speech-recognition-floating-menu></asg-speech-recognition-floating-menu>
  <asg-drawing-tools-floating-menu></asg-drawing-tools-floating-menu>
  <asg-search-floating-menu></asg-search-floating-menu>
  <asg-highlighter-floating-menu></asg-highlighter-floating-menu>
  <asg-epub-annotations-floating-menu></asg-epub-annotations-floating-menu>
  <asg-mark-up-floating-menu></asg-mark-up-floating-menu>
  <asg-word-predictor-dialog></asg-word-predictor-dialog>
  <asg-custom-input-iframe></asg-custom-input-iframe>
  <asg-epub-viewer-overlay></asg-epub-viewer-overlay>
  <asg-keyboard-event-handler></asg-keyboard-event-handler>

  @if (isExamModeAccessible) {
  <asg-exam-mode-floating-menu></asg-exam-mode-floating-menu>
  }
  @if (examRestrictionsAreActive) {
    <asg-exam-tamper-protection></asg-exam-tamper-protection>
    <asg-key-info></asg-key-info>
  }
}
</div>
